(function () {
  const el = document.getElementById('fd-xmas-guarantee');
  if (!el) return;

  const tz = el.getAttribute('data-timezone') || 'Europe/Bucharest';
  const deadlineStr = el.getAttribute('data-deadline'); // ex: 2025-12-19T14:00:00

  // "Acum" în timezone RO (Bucharest)
  function nowInTZ(timeZone) {
    const parts = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    const get = (t) => parts.find(p => p.type === t)?.value;
    return new Date(`${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}:${get('second')}`);
  }

  const deadline = new Date(deadlineStr);

  function update() {
    const now = nowInTZ(tz);

    if (now <= deadline) {
      el.style.display = '';
      el.innerHTML = `
        <div>
          <strong>🎄 Livrare garantată până de Crăciun</strong><br>
          Plasează comanda până în <strong>19 decembrie, ora 14:00</strong> și noi garantăm că ajunge la tine până de Crăciun.
          <div class="muted">*Valabil pentru livrări în România.</div>
        </div>
      `;
    } else {
      el.style.display = 'none';
    }
  }

  update();
  setInterval(update, 60000);
})();
